//login.js
import React, { useState } from "react";
import { Box, TextField, Button, Paper, CircularProgress, Backdrop, Alert } from "@mui/material";
import { adminLogin } from "../../../services/adminService";
import logo from "../../../assets/images/logoDark.svg";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const result = await adminLogin({ email, password });
      localStorage.setItem('adminUserData', JSON.stringify(result));
      navigate('/admin/dashboard');
    } catch (err) {
      let msg = "Login failed";
      if (err.response && err.response.data && err.response.data.message) {
        msg = err.response.data.message;
      }
      setError(msg);
      console.error("Login failed:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#f5f5f5",
        flexDirection: "column",
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 4,
          minWidth: 340,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          borderRadius: 3,
        }}
      >
        <img
          src={logo}
          alt="getLista Logo"
          style={{ width: 220, marginBottom: 24 }}
        />
        {error && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>}
        <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
          <TextField
            label="Email or Username"
            variant="outlined"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
          />
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2, py: 1, fontWeight: 600 }}
          >
            Login
          </Button>
        </Box>
      </Paper>
      <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 2 }}>
        <CircularProgress size={80} thickness={4} color="inherit" />
      </Backdrop>
    </Box>
  );
}
